import { BrowserRouter, Route, Routes } from "react-router-dom";
import AnexoI1 from "../pages/anexoI1/AnexoI1";
import AnexoII1 from "../pages/anexoII1/AnexoII1";
import PuestosOrdenPreferencia from "../pages/anexoII2/PuestosOrdenPreferencia";
import SeleccionPuestos from "../pages/anexoII2/SeleccionPuestos";
import AnexoII3 from "../pages/anexoII3/AnexoII3";
import ConcursoPuestosSingularizados from "../pages/concursos/Concurso";
import NotFound from "../pages/errores/notFound/NotFound";
import InstruccionesSolicitud from "../pages/instruccionesSolicitud/InstruccionesSolicitud";
import Concurso from "../pages/listado_concursos/Concursos";
import NivelCarrera from "../pages/nivelCarrera/NivelCarrera";
import SolicitudAnuladaEnCurso from "../pages/solicitudAnuladaEnCurso/SolicitudAnuladaEnCurso";
import SolicitudCarreraV2 from "../pages/solicitudCarrera/SolicitudCarreraV2.jsx";
import "../resources/sass/index.scss";
import ErrorNoControlado from "./../pages/errores/errorNoControlado/ErrorNoControlado";
import NoAutorizado from "./../pages/errores/noAutorizado/NoAutorizado";
import Home from "./../pages/home/Home";
import Login from "./../pages/login/Login";
//import AnexoII4 from "../pages/anexoII4/AnexoII4";
import {
  RequireAuth,
  RequireAuthAccesoCredenciales,
  RequireAuthAdmin,
  RequireAuthTieneA1,
} from "../guards/PageGuards";
import Adminitracion from "../pages/admin/Administracion";
import AdqusicionVista from "../pages/adquisicion/AdqusicionVista";
import BorradorNomina from "../pages/borradorNomina/BorradorNomina";
import ConsModSolicitudes from "../pages/concursos/ConsModSolicitudes";
import InstruccionesSolicitudA1A2 from "../pages/instruccionesSolicitudA1A2/InstruccionesSolicitudA1A2";
import DetallePersonal from "../pages/personal/DetallePersonal";
import SolicitudAdquisicionA1 from "../pages/solicitudAdquisicionA1/SolicitudAdquisicionA1";
import SolicitudAdquisicionA2 from "../pages/solicitudAdquisicionA2/SolicitudAdquisicionA2";
// import VariacionDatosPersonal from "../pages/variacionDatosPersonal/VariacionDatosPersonal";
import MisActosAdmin from "../pages/misActosAdmin/MisActosAdmin";
import VariacionDatosPersonal from "../pages/variacionDatosPersonal/VariacionDatosPersonal";
import BorradorActos from "./molecules/tabs/borradorActos/BorradorActos";
import DescargarBorradorActos from "./molecules/tabs/descargarBorradorActos/DescargarBorradorActos.jsx";
import DescargarDocumentosActos from "./molecules/tabs/descargarDocumentosActos/DescargarDocumentosActos.jsx";
import DocumentosActos from "./molecules/tabs/documentosActos/DocumentosActos";
import PresentarBorradorActos from "./molecules/tabs/presentarBorradorActos/PresentarBorradorActos";

import DescargarResolucionActos from "./molecules/descargarResolucionActos/DescargarResolucionActos.jsx";
import DescargarActosPresentadas from "./molecules/tabs/descargarActosPresentadas/DescargarActosPresentadas.jsx";

import { HistoryProvider } from "../hooks/useHistoryContext.jsx";
import ListadoActos from "../pages/actos/ListadoActos.jsx";
import AnexoI1Limpio from "../pages/anexoI1/AnexoI1Limpio.jsx";
import CentrosOrdenPreferencia from "../pages/anexoI2/CentrosOrdenPreferencia.jsx";
import SeleccionCentros from "../pages/anexoI2/SeleccionCentros.jsx";
import AnexoI3Limpio from "../pages/anexoI3/AnexoI3Limipio.jsx";
import AnexoII4Limpio from "../pages/anexoII4/AnexoII4Limpio.jsx";
import CambioCuentaCorriente from "../pages/cambioCuentaCorriente/CambioCuentaCorriente.jsx";
import DescargarSolicitudConcurso from "../pages/concursos/DescargarSolicitudConcurso.jsx";
import HojaServiciosPrestados from "../pages/hojaServiciosPrestados/HojaServiciosPrestados.jsx";
import InstruccionesSolicitudPopUp from "../pages/instruccionesSolicitud/InstruccionesSolicitudPopUp.jsx";
import VerPDFirpfHab from "../pages/irpfHabilitado/VerPDFirpfHab.jsx";
import LoginClave from "../pages/login/LoginClave.jsx";
import DatosAdicionales from "../pages/misActosAdmin/datosAdicionales/DatosAdicionales.jsx";
import ResolucionMisActos from "../pages/misActosAdmin/resolucionMisActos/ResolucionMisActos.jsx";
import ReconNivelCarrera from "../pages/nivelCarrera/ReconNivelCarrera.jsx";
import RNSolicitudPDF from "../pages/nivelCarrera/RNSolicitudPDF.jsx";
import ReconServiciosPrevios from "../pages/reconServiciosPrevios/ReconServiciosPrevios.jsx";
import SolicitudCarrera from "../pages/solicitudCarrera/SolicitudCarreraV2NuevoRN.jsx";
import SolicitudReconServiciosPrevios from "../pages/solicitudReconServiciosPrevios/SolicitudReconServiciosPrevios.jsx";
import TokenExpirado from "../pages/tokenEXP/TokenExpirado.jsx";
import JustificacionActoPresentado from "../pages/variacionDatosPersonal/pdfPresentadasJusitificacion/JustificacionActoPresentado.jsx";
import ResolucionActoPresentado from "../pages/variacionDatosPersonal/pdfPresentadasResolucion/ResolucionActoPresentado.jsx";
import Clave from "./../pages/clave/Clave";
import ClaveError from "./../pages/clave_error/ClaveError";
import { AuthProvider } from "./AuthContext.jsx";
import Accesibilidad from "./molecules/footer/accesibilidad/Accesibilidad.jsx";
import AvisoLegal from "./molecules/footer/avisoLegal/AvisoLegal.jsx";
import MapaWeb from "./molecules/footer/mapaWeb/MapaWeb.jsx";
import RouteListener from "./molecules/header/RouteListener.jsx";
import VerIrpfPDF from "./molecules/modals/consultaIRPF/VerIrpfPDF.jsx";
import VerNominaPDF from "./molecules/modals/consultaNominas/VerNominaPDF.jsx";
import { useEffect, useState } from "react";
import ModalMensajes from "./molecules/modals/modalMensajes/ModalMensajes.jsx";
import PresentarSolicitudConcurso from "../pages/concursos/PresentarSolicitudConcurso.jsx";
import AnexoIII1 from "../pages/anexoIII1/AnexoIII1.jsx";


// import Header from "./molecules/header/Header.jsx";
/**
 * Enrutador principal
 *
 * @returns rutas de la aplicación
 */
const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <HistoryProvider>
        <RouteListener />  {/* Esto debe estar dentro de HistoryProvider */}
        {/* Asegúrate de que el Header está dentro de HistoryProvider */}
        <Routes>

          <Route
            path="/claveError"
            element={
              <ClaveError />
            }
          />

          <Route
            path="/clave"
            element={
              <Clave />
            }
          />
          <Route path="/lgn" element={
            <RequireAuthAccesoCredenciales>
              <Login />
            </RequireAuthAccesoCredenciales>

          } />
          <Route path="/login" element={<LoginClave />} />

          <Route path="/" element={<LoginClave />} />

          {/* PR */}
          <Route
            path="/home"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />




          <Route
            path="/carrera"
            element={
              <RequireAuth>
                <NivelCarrera />
              </RequireAuth>
            }
          />

          <Route
            path="/rnsolicitudpdf/:id"
            element={
              <RequireAuth>
                <RNSolicitudPDF />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/concursos"
            element={
              <RequireAuth>
                <Concurso />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitudCarrera"
            element={
              <RequireAuth>
                <SolicitudCarreraV2 />
              </RequireAuth>
            }
          />

          <Route
            path="/solicitudCarreraNuevo"
            element={
              <RequireAuth>
                <SolicitudCarrera />
              </RequireAuth>
            }
          />

          <Route
            path="/solicitudCarreraNuevo/:id"
            element={
              <RequireAuth>
                <SolicitudCarrera />
              </RequireAuth>
            }
          />

          <Route
            path="/instruccionesSolicitud"
            element={
              <RequireAuth>
                <InstruccionesSolicitud />
              </RequireAuth>
            }
          />

          <Route
            path="/instruccionesSolicitudpopup"
            element={
              <RequireAuth>
                <InstruccionesSolicitudPopUp />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitudAnuladaEnCurso"
            element={
              <RequireAuth>
                <SolicitudAnuladaEnCurso />
              </RequireAuth>
            }
          />
          <Route
            path="/concurso/:id"
            element={
              <RequireAuth>
                <ConcursoPuestosSingularizados />
              </RequireAuth>
            }
          />

          <Route
            path="/descargaSolicitudConcurso/:idCon/:idSol"
            element={
              <RequireAuth>
                <DescargarSolicitudConcurso />
              </RequireAuth>
            }
          />
          <Route
            path="/seleccionPuestos/:idCon/:idSol"
            element={
              <RequireAuth>
                <SeleccionPuestos />
              </RequireAuth>
            }
          />
          <Route
            path="/seleccionCentros/:idCon/:idSol"
            element={
              <RequireAuth>
                <SeleccionCentros />
              </RequireAuth>
            }
          />
          <Route
            path="/puestosOrdenPreferencia/:idCon/:idSol"
            element={
              <RequireAuth>
                <PuestosOrdenPreferencia />
              </RequireAuth>
            }
          />

          <Route
            path="/centrosOrdenPreferencia/:idCon/:idSol"
            element={
              <RequireAuth>
                <CentrosOrdenPreferencia />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoi_1/:idcon"
            element={
              <RequireAuth>
                <AnexoI1Limpio />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoI1/:idcon"
            element={
              <RequireAuth>
                <AnexoI1 />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoi_1/:idcon/:idsol"
            element={
              <RequireAuth>
                <AnexoI1Limpio />
              </RequireAuth>
            }
          />
          <Route
            path="/consModSolicitudes/:idCon/:idSol"
            element={
              <RequireAuth>
                <ConsModSolicitudes />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoi_3/:idcon/:idsol"
            element={
              <RequireAuth>
                <AnexoI3Limpio />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoii_1/:idcon"
            element={
              <RequireAuth>
                <AnexoII1 />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoii_1/:idcon/:idsol"
            element={
              <RequireAuth>
                <AnexoII1 />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoii_3/:idcon/:idsol"
            element={
              <RequireAuth>
                <AnexoII3 />
              </RequireAuth>
            }
          />
          <Route
            path="/anexoii_4/:idcon/:idsol"
            element={
              <RequireAuth>
                <AnexoII4Limpio />
              </RequireAuth>
            }
          />

          <Route
            path="/anexoiii_1/:idcon"
            element={
              <RequireAuth>
                <AnexoIII1 />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/nomina"
            element={
              <RequireAuth>
                <BorradorNomina />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/nominaPDF"
            element={
              <RequireAuth>
                <VerNominaPDF />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/irpfPDF"
            element={
              <RequireAuth>
                <VerIrpfPDF />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/detallePersonal"
            element={
              <RequireAuth>
                <DetallePersonal />
              </RequireAuth>
            }
          />
          <Route
            path="/adquisicion"
            element={
              <RequireAuth>
                <AdqusicionVista />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitudAdquisicionA1"
            element={
              <RequireAuthTieneA1>
                <RequireAuth>
                  <SolicitudAdquisicionA1 />
                </RequireAuth>
              </RequireAuthTieneA1>
            }
          />
          <Route
            path="/solicitudAdquisicionA1/:id"
            element={
              <RequireAuth>
                <SolicitudAdquisicionA1 />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitudAdquisicionA2"
            element={
              <RequireAuth>
                <SolicitudAdquisicionA2 />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitudAdquisicionA2/:id"
            element={
              <RequireAuth>
                <SolicitudAdquisicionA2 />
              </RequireAuth>
            }
          />
          <Route
            path="/instruccionesSolicitudA1A2"
            element={
              <RequireAuth>
                <InstruccionesSolicitudA1A2 />
              </RequireAuth>
            }
          />

          <Route
            path="/variacionDatosPersonales"
            element={
              <RequireAuth>
                <VariacionDatosPersonal />
              </RequireAuth>
            }
          />
          <Route
            path="/cambioCuentaCorriente"
            element={
              <RequireAuth>
                <CambioCuentaCorriente />
              </RequireAuth>
            }
          />
          <Route
            path="/reconNivelCarrera"
            element={
              <RequireAuth>
                <ReconNivelCarrera />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/misActosAdmin"
            element={
              <RequireAuth>
                <MisActosAdmin />
              </RequireAuth>
            }
          />

          <Route
            path="/borradorActos"
            element={
              <RequireAuth>
                <BorradorActos />
              </RequireAuth>
            }
          />
          <Route
            path="/borradorActos/:id"
            element={
              <RequireAuth>
                <BorradorActos />
              </RequireAuth>
            }
          />
          <Route
            path="/documentosActos/:id"
            element={
              <RequireAuth>
                <DocumentosActos />
              </RequireAuth>
            }
          />
          <Route
            path="/presentarBorradorActos/:id"
            element={
              <RequireAuth>
                <PresentarBorradorActos />
              </RequireAuth>
            }
          />
          <Route
            path="/descargarBorradorActos/:id"
            element={
              <RequireAuth>
                <DescargarBorradorActos />
              </RequireAuth>
            }
          />
          <Route
            path="/descargarDocumentoActos/:idActo/:idDoc"
            element={
              <RequireAuth>
                <DescargarDocumentosActos />
              </RequireAuth>
            }
          />
          <Route
            path="/descargarPresentadasActos/:id"
            element={
              <RequireAuth>
                <DescargarActosPresentadas />
              </RequireAuth>
            }
          />
          <Route
            path="/descargarResolucionActos/:id"
            element={
              <RequireAuth>
                <DescargarResolucionActos />
              </RequireAuth>
            }
          />

          <Route
            path="/misActosAdmin/:xsolactadm/resolucion"
            element={
              <RequireAuth>
                <ResolucionMisActos />
              </RequireAuth>
            }
          />
          <Route
            path="/misActosAdmin/:xsolactadm/datosAdicionales"
            element={
              <RequireAuth>
                <DatosAdicionales />
              </RequireAuth>
            }
          />
          {/* Cambie la rutas porque no tenia sentido que fueran especificas para el s1 */}
          <Route
            path="/actos/:xsolactadm/justficacion"
            element={
              <RequireAuth>
                <JustificacionActoPresentado />
              </RequireAuth>
            }
          />

          <Route
            path="/actos/:xsolactadm/resolucion"
            element={
              <RequireAuth>
                <ResolucionActoPresentado />
              </RequireAuth>
            }
          />

          {/* PR */}
          <Route
            path="/irpfHabilitado"
            element={
              <RequireAuth>
                <VerPDFirpfHab />
              </RequireAuth>
            }
          />


          {/* PR */}
          <Route
            path="/listadoactos"
            element={
              <RequireAuth>
                <ListadoActos />
              </RequireAuth>
            }
          />

          <Route
            path="/admin"
            element={
              <RequireAuthAdmin>
                <Adminitracion />
              </RequireAuthAdmin>
            }
          />

          <Route
            path="/hojaServiciosPrestados"
            element={
              <RequireAuth>
                <HojaServiciosPrestados />
              </RequireAuth>
            }
          />

          <Route
            path="/reconServiciosPrevios"
            element={
              <RequireAuth>
                <ReconServiciosPrevios />
              </RequireAuth>
            }
          />

          <Route
            path="/solReconServiciosPrevios"
            element={
              <RequireAuth>
                <SolicitudReconServiciosPrevios />
              </RequireAuth>
            }
          />

          <Route
            path="/presentarSolicitudConcursos/:idCon/:idSol"
            element={
              <RequireAuth>
                <PresentarSolicitudConcurso />
              </RequireAuth>
            }
          />

          <Route path="/error" element={<ErrorNoControlado />} />
          <Route path="/noAutorizado" element={<NoAutorizado />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/accesibilidad" element={<Accesibilidad></Accesibilidad>} />
          <Route path="/avisoLegal" element={<AvisoLegal></AvisoLegal>} />
          <Route path="/mapaWeb" element={<MapaWeb></MapaWeb>} />
          <Route path="/tokenexp" element={<TokenExpirado />} />


        </Routes>
        <GlobalErrorModal />
      </HistoryProvider>
    </BrowserRouter>
  </AuthProvider>
);

const GlobalErrorModal = () => {
  const [show, setShow] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [destinos, setDestinos] = useState({
    destinoAviso: "",
    destinoCerrar: ""
  })
  const handleClose = () => setShow(false);

  useEffect(() => {
    const handleError = (e) => {
      setMensaje(e.detail.content);
      setDestinos({
        destinoAviso: e.detail.destinoAviso,
        destinoCerrar: e.detail.destinoCerrar
      })
      setShow(true);
    };
    window.addEventListener("showErrorModal", handleError);
    return () => window.removeEventListener("showErrorModal", handleError);
  }, []);

  return (
    <ModalMensajes
      show={show}
      handleClose={handleClose}
      texto={mensaje}
      tipo="tituloModal rojo"
      destinoAviso={destinos.destinoAviso}
      destinoCerrar={destinos.destinoCerrar}
    />
  );
};

export default App;
